var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEditModal = function SvgIconEditModal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 48 49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.8251598,-4 L19.1747079,-4 C17.4242447,-4 16,-2.58634446 16,-0.848895866 L16,47.1700745 C16,47.1708627 16,47.6173424 16.1938783,47.8548344 L21.861213,57.3556978 C22.0994253,57.7550207 22.5323099,58 23,58 C23.4676901,58 23.9005747,57.7550207 24.138787,57.3556978 L29.8061217,47.8548344 C29.9690324,47.6061771 30,47.170994 30,47.1700745 L30,-0.848895866 C30,-2.58634446 28.5756229,-4 26.8251598,-4 L26.8251598,-4 Z M18.646803,45.8566438 L18.646803,6.90256547 L21.6765985,6.90256547 L21.6765985,45.8566438 L18.646803,45.8566438 Z M24.3232692,6.90256547 L27.3530646,6.90256547 L27.3530646,45.8566438 L24.3232692,45.8566438 L24.3232692,6.90256547 Z M18.646803,-0.848895866 C18.646803,-1.13774817 18.8836919,-1.37287579 19.1747079,-1.37287579 L26.8251598,-1.37287579 C27.1163081,-1.37287579 27.3530646,-1.13774817 27.3530646,-0.848895866 L27.3530646,4.27544126 L18.646803,4.27544126 L18.646803,-0.848895866 Z M22.9998677,54.1083096 L19.6447801,48.483768 L26.3548229,48.483768 L22.9998677,54.1083096 Z",
    id: "editIcon-path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editIcon-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit Icon",
    transform: "translate(-1.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "editIcon-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#editIcon-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "editIcon-Mask",
    fill: "#000000",
    fillRule: "nonzero",
    transform: "translate(23.000000, 27.000000) rotate(44.000000) translate(-23.000000, -27.000000) ",
    xlinkHref: "#editIcon-path-1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEditModal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_edit_modal.7727a5b3.svg";
export { ForwardRef as ReactComponent };